/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EmailTemplateType {
  CONFIRMATION = 'confirmation',
  PRE = 'pre',
  POST = 'post',
  VOUCHER = 'voucher',
  CANCELLATION = 'cancellation',
  ABANDONEDCART = 'abandonedcart',
  PASS_CONFIRMATION = 'pass_confirmation',
  COURSE_CONFIRMATION = 'course_confirmation',
}
